import cookie from './cookie';

export default () => (window.start?.settings?.http_only_flag_set_on_session_id_cookie
  ? '-1'
  : cookie.session());
